import { useMemo, useState } from 'react';

import { MultiSelectContextField } from 'src/common/FormField/MultiSelectContextField';
import { usePayerOrganizationOptions } from 'src/features/payer/usePayerOrganizationOptions';

import { FormContextFieldRulesProps } from './FormField/FormContextField';

export function MultiSelectPayerField({
  fieldPath,
  rules,
}: {
  fieldPath: string;
  rules?: FormContextFieldRulesProps;
}) {
  const [query, setQuery] = useState('');
  const { options, isLoading, isFetching } = usePayerOrganizationOptions(query);
  const label = useMemo(() => {
    return rules?.required ? 'Payers *' : 'Payers';
  }, [rules?.required]);

  return (
    <div>
      <MultiSelectContextField
        options={options}
        fieldPath={fieldPath}
        label={label}
        disabled={isLoading || isFetching}
        searchable
        query={query}
        setQuery={setQuery}
        rules={rules}
      />
    </div>
  );
}
